import { ActionSheetProvider } from '@expo/react-native-action-sheet'
import { Stack } from 'expo-router'
import { Suspense } from 'react'
import { LogBox } from 'react-native'
import { ThemeProvider as ReactNativeElementsThemeProvider } from 'react-native-elements'
import { PaperProvider, MD2LightTheme, MD2DarkTheme } from 'react-native-paper'
import { Provider } from 'react-redux'
import { SessionProvider } from '~/context/auth'
import { RemoteConfigProvider } from '~/context/remoteConfig'
import { RollbarErrorBoundary } from '~components/RollbarErrorBoundary'
import store from '~redux'
import { useTheme } from '~theme/ThemeManager'
import fontawesome from '~utils/fontawesome'
import {
  ThemeProvider as ReactNavigationThemeProvider,
  DarkTheme as NavigationDarkTheme,
} from '@react-navigation/native'
import { DefaultReactNavigationTheme } from '~theme'
import merge from 'deepmerge'

const CombinedDefaultTheme = merge(MD2LightTheme, DefaultReactNavigationTheme)
const CombinedDarkTheme = merge(MD2DarkTheme, NavigationDarkTheme)

fontawesome()

if (LogBox) {
  LogBox.ignoreLogs([
    'Failed prop type: The prop `source` is marked as required in `_class`, but its value is `null`',
    'The AVPlayerItem instance has failed with the error code -1100 and domain "NSURLErrorDomain".',
  ])
}

export default function Root() {
  const { mode } = useTheme()

  return (
    <ReactNavigationThemeProvider
      value={mode === 'dark' ? CombinedDarkTheme : CombinedDefaultTheme}
    >
      <ReactNativeElementsThemeProvider>
        <PaperProvider theme={mode === 'dark' ? CombinedDarkTheme : CombinedDefaultTheme}>
          <RollbarErrorBoundary>
            <Provider store={store}>
              <ActionSheetProvider>
                <Suspense>
                  <RemoteConfigProvider>
                    <SessionProvider>
                      <Stack>
                        <Stack.Screen
                          name="(logged-in)"
                          options={{
                            headerTitle: '',
                            headerShown: false,
                          }}
                        />
                        <Stack.Screen
                          name="login"
                          options={{
                            headerTitle: 'Login',
                            headerShown: false,
                          }}
                        />
                        <Stack.Screen
                          name="diagnostics"
                          options={{
                            headerTitle: 'Diagnostics',
                          }}
                        />
                        <Stack.Screen
                          name="terms-and-conditions"
                          options={{
                            headerTitle: 'Tersm and Conditions',
                          }}
                        />
                      </Stack>
                    </SessionProvider>
                  </RemoteConfigProvider>
                </Suspense>
              </ActionSheetProvider>
            </Provider>
          </RollbarErrorBoundary>
        </PaperProvider>
      </ReactNativeElementsThemeProvider>
    </ReactNavigationThemeProvider>
  )
}
